import $ from 'jquery';

export default class {
  constructor(el) {
    const p = this;
    p.$el = $(el);

    p.$el.find(".js-tabbed-content__tab").on("tabActive", function(){
      p.$el.find(".js-map-tooltiped").addClass("is-hidden");
      p.$el.find(".js-map-department").removeClass("is-glowing");
      var postcodes = "";
      var cities = $(this).attr("data-cities").split(",");
      setTimeout(function(){
        $.each(cities, function(index, id) {
          var $city = p.$el.find(`.js-map-tooltiped[data-id="${id}"]`);
          var postcode = $city.attr("data-tooltip-postcode");
          $city.removeClass('is-hidden');
          postcodes+= `.js-map-department[data-postcode="${postcode}"],`;
        });
        p.$el.find(postcodes.substring(0, postcodes.length - 1)).addClass("is-glowing");
      }, 150);
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/components/InterventionMap.js